import * as React from "react";
import { cn } from "@/lib/utils";

interface GradientTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  variant?: "accent" | "primary" | "shimmer" | "glow" | "rainbow" | "subtle";
  as?: "span" | "h1" | "h2" | "h3" | "h4" | "p";
  animate?: boolean;
}

const variantClasses: Record<string, string> = {
  accent: "bg-gradient-to-r from-accent via-accent/90 to-accent bg-clip-text text-transparent drop-shadow-sm",
  primary: "bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent bg-[length:200%_auto]",
  shimmer: "bg-gradient-to-r from-accent via-primary-foreground to-accent bg-clip-text text-transparent bg-[length:200%_auto] animate-gradient-shift",
  glow: "bg-gradient-to-r from-accent to-accent/80 bg-clip-text text-transparent [filter:drop-shadow(0_0_12px_hsl(var(--accent)/0.5))]",
  rainbow: "bg-gradient-to-r from-accent via-primary to-accent bg-clip-text text-transparent bg-[length:300%_auto] animate-gradient-shift",
  subtle: "bg-gradient-to-r from-foreground via-muted-foreground to-foreground bg-clip-text text-transparent",
};

export const GradientText = ({
  children,
  className,
  variant = "accent",
  as: Component = "span",
  ...props
}: GradientTextProps) => {
  return (
    <Component
      className={cn(variantClasses[variant], className)}
      {...props}
    >
      {children}
    </Component>
  );
};
